import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import type { YouTubeVideo } from '@kidstube/types';
import { decodeHtmlEntities } from '@kidstube/lib/text';

interface VideoCardProps {
  video: YouTubeVideo;
}

export default function VideoCard({ video }: VideoCardProps) {
  const timeAgo = formatDistanceToNow(new Date(video.publishedAt), {
    addSuffix: true,
  });
  const videoTitle = decodeHtmlEntities(video.title);
  const channelTitle = decodeHtmlEntities(video.channelTitle);

  return (
    <Link
      to={`/watch/${video.id}`}
      className="video-card"
      onClick={() => {
        sessionStorage.setItem('kidstube.playRequest', video.id);
      }}
    >
      <div className="video-thumbnail">
        <img src={video.thumbnail} alt={videoTitle} loading="lazy" />
      </div>
      <div className="video-info">
        <h3 className="video-title">{videoTitle}</h3>
        <p className="video-channel">{channelTitle}</p>
        <div className="video-meta">
          <span>{timeAgo}</span>
        </div>
      </div>
    </Link>
  );
}
